import { QueryClient } from "@tanstack/react-query";

/**
 * One client for the process.
 *
 * It lives here rather than in `main.tsx` because the router needs it too:
 * `appRoute.beforeLoad` reads the session through this cache, and a second
 * client would defeat the point by giving the guard its own empty one.
 *
 * Retries are off: every failure this app can produce is a pipeline that did
 * not run, and retrying a 503 three times turns a clear message into a slow
 * one. Each hook sets its own `staleTime`.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

/** How long a resolved session is trusted before the guard revalidates it. */
export const SESSION_STALE_MS = 5 * 60_000;

/** The cache key for the signed-in user, shared by the guard and any consumer. */
export const meQueryKey = ["me"] as const;
